import React from "react";
import styles from "./interestsActivities.module.css";

type Props = {
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
}

const ActivityForm: React.FC<Props> = (props) => (
  <form id="activityForm" onSubmit={props.onSubmit}>
    <textarea name="note" className="form-control disabled" />
    <div className={styles.addNoteDiv}>
      <button
        id="activitySubmit"
        type="submit"
        className={`btn btn-primary  ${props.isLoading ? "disabled" : ""} pull-right`}
      >
        {props.isLoading ? "Sending..." : "Add Note"}
      </button>
    </div>
  </form>
);

export default ActivityForm;
